import { DatabaseTable } from '../../../shared/components/ui/DatabaseTable';
import { Box, Chip, Typography } from '@mui/material';
import { useReport } from '../context';
import { handlePdf } from '../../../shared/services/reports/reportService';


export function ReportDetailTable() {
  const { details, isLoading } = useReport();

  // Handlers de exemplo
  const handleView = (row: any) => {
    // Implementar visualização
    alert(`Visualizar: ${row.name}`);
  };
 

  const columns = [
    {
      field: 'type',
      headerName: 'TIPO',
      width: 120,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          sx={{
            background: params.value === 'Morador' ? '#6C63FF' : '#22C55E',
            color: '#fff',
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            px: 1.5,
            height: 28,
          }}
          size="small"
        />
      ),
    },
    {
      field: 'name',
      headerName: 'NOME',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontWeight={500}>{params.value}</Typography>
      ),
    },
    {
      field: 'date',
      headerName: 'DATA',
      width: 140,
      renderCell: (params: any) => (
        <Typography>{params.value}</Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: 120,
      renderCell: (params: any) => (
        <Chip
          label={params.value}
          sx={{
            background: params.value === 'Ativo' ? '#22C55E' : '#FFA500',
            color: '#fff',
            fontWeight: 600,
            fontSize: 13,
            borderRadius: 2,
            px: 1.5,
            height: 28,
          }}
          size="small"
        />
      ),
    },
    // Remover coluna actions customizada!
  ];

  return (
    <Box sx={{ background: '#fff', borderRadius: 3, p: 3, mt: 3 }}>
      <Typography variant="h6" fontWeight={700} mb={2}>Relatório Detalhado</Typography>
      <DatabaseTable
        rows={details}
        columns={columns}
        loading={isLoading}
        onView={handleView}
        onPdf={handlePdf}
        hideDelete
        hideEdit
        sx={{
          // Customização global dos ícones de ação (se DatabaseTable aceitar sx)
          '& .MuiIconButton-root': {
            color: '#6C63FF',
          },
        }}
      />
    </Box>
  );
} 